<section class="messenger" id="messenger">

    <!-- Nota informativa -->
    <div class="info-banner" role="status">
        <span class="info-banner-icon" aria-hidden="true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#004877" stroke-width="1.6"/>
                <path d="M12 8h.01M11 12h1v5h1" stroke="#004877" stroke-width="1.8"
                        stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </span>
        <p class="info-banner-text">{{ infoText }}</p>
    </div>

    <!-- Chat panel -->
    <div class="chat-panel">

        <div class="chat-card chat-card--messages">
            <app-event-messenger-history [data]="data"></app-event-messenger-history>
        </div>

        <div class="chat-card chat-card--send">
            <app-event-messenger-send [data]="data"></app-event-messenger-send>
        </div>

    </div>

</section>
